import { clsx, type ClassValue } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

/**
 * src/styles/app.css 의 TDS 토큰 이름을 tailwind-merge 에 알려 준다.
 * 알려 주지 않으면 `text-h2`(크기)와 `text-fg-primary`(색)를 같은 그룹으로 보고 앞의 것을 지운다.
 */
const twMerge = extendTailwindMerge({
  extend: {
    theme: {
      text: [
        'display-1',
        'display-2',
        'h1',
        'h2',
        'h3',
        'h4',
        'title-1',
        'title-2',
        'body-1',
        'body-2',
        'body-3',
        'label-l',
        'label-m',
        'label-s',
        'caption',
        'caption-s',
      ],
      radius: ['xs', 's', 'm', 'l', 'xl', '2xl', '3xl', '4xl'],
      shadow: ['1', '2', '3', 'toast', 'sheet'],
      ease: ['tds', 'tds-out'],
    },
  },
});

/** 조건부 클래스를 합치고 충돌하는 Tailwind 클래스는 뒤의 것을 남긴다 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
